import { render, staticRenderFns } from "./base-pie-chart.vue?vue&type=template&id=93179b3a&scoped=true"
import script from "./base-pie-chart.vue?vue&type=script&lang=js"
export * from "./base-pie-chart.vue?vue&type=script&lang=js"
import style0 from "./base-pie-chart.vue?vue&type=style&index=0&id=93179b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93179b3a",
  null
  
)

export default component.exports